import React from "react";
import phoneIMG from "../../assets/app/FunctionsSection/Movil.png";
import phone2IMG from "../../assets/app/FunctionsSection/Movil-2.png";
import { useTranslation } from "react-i18next";

import "../../styles/app/FunctionsSection.css";

const FunctionsSection: React.FC = () => {
  const { t } = useTranslation();

  return (
    <section className="functions-section">
      <div className="functions-grid">
        {/* Columna Izquierda */}
        <div className="function-card function-left-column">
          <h1 className="function-title">{t("functionsSection.title1")}</h1>
          <p className="function-desc">{t("functionsSection.description1")}</p>
        </div>

        {/* Columna Central (Móvil) */}
        <div className="function-card function-center-column">
          <img className="function-image-big" src={phoneIMG} alt="phone" />
          <img className="function-image-tiny" src={phone2IMG} alt="phone" />
        </div>

        {/* Columna Derecha */}
        <div className="function-card function-right-column">
          <h1 className="function-title">{t("functionsSection.title2")}</h1>
          <p className="function-desc">{t("functionsSection.description2")}</p>
        </div>
      </div>
    </section>
  );
};

export default FunctionsSection;
